export default __webpack_public_path__ + "static/media/al-badar logo 01.9aa6b258.png";